const IS_DEVELOPMENT = process.env.NODE_ENV !== 'production';

// 同一origin化（#208）により API/アセットは常に相対パスで参照する。
// 後方互換のため空文字の BACKEND_URL を残す（`${BACKEND_URL}/...` が相対になる）。
export const BACKEND_URL = '';

// ログAPIのURL（同一origin・相対）
export const LOG_API_URL = '/api/logs';

// 環境設定
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export { IS_DEVELOPMENT };

// デモモード設定
// REACT_APP_DEMO_MODE=true のときだけ、バックエンド無しで動く静的デモに切り替わる。
// false（既定）のときは本番挙動を一切変えない。Cloudflare Pages のデモ環境でのみ true を渡す。
export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';

// ビルド事故の検知: 本番ビルドにデモモードが混入すると、許可リスト認証が本番URLで
// 有効化され実質的な認証バイパスになる。ビルド時 env の取り違えに気づけるよう警告する。
// テスト環境では IS_PRODUCTION=false で到達しない防御ガードのためカバレッジ対象外とする。
/* v8 ignore start */
if (IS_PRODUCTION && DEMO_MODE) {
  // eslint-disable-next-line no-console
  console.error(
    '[config] 本番ビルドで REACT_APP_DEMO_MODE=true が有効です。デモ環境以外では無効化してください。'
  );
}
/* v8 ignore stop */